<template>
  <div class="searchBackground">
    <div
      id="scrollToTopAnchor"
      class="position-absolute"
      style="top: 0; left: 0"
    ></div>
    <mdb-container class="search mb-5">
      <transition name="fade">
        <a
          href="scrollToTopAnchor"
          v-show="showScrollToTop"
          class="
            search__scroll-top-button
            btn-floating btn-md btn-isi
            ml-0
            d-md-none
            position-fixed
          "
          v-mdb-smooth
        >
          <mdb-icon icon="angle-up" />
        </a>
      </transition>
      <bing-location-map
        v-if="mapRendered"
        v-show="showMaps"
        @closeMap="showMaps = false"
      />
      <mdb-row v-if="dataLoaded" class="d-flex mb-2 no-gutters">
        <mdb-col class="d-flex justify-content-end">
          
          <mdb-btn icon="plus" 
           class="btn-isi btn-sm rounded mx-1 px-3"
           v-if="this.user && this.user.role == 3"
           @click="$store.commit('setCurrentModal', { type: 'putTestStudioModal' })"
          >
            Add Studio
          </mdb-btn>

          <share-search-button />
        </mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col lg="4">
          <search-bar
            v-if="dataLoaded"
            :key="searchBarRenderKey"
            ref="searchBar"
            @mapsButtonClicked="handleMapsButtonClicked"
          />
        </mdb-col>
        <mdb-col class="pl-lg-0">
          <template v-if="dataLoaded">
            <search-tag
              class="mb-2 mr-2 mb-lg-1 mr-lg-1"
              v-for="(el, key) in searchTags"
              :label="el"
              :key="'searchTag-' + key"
              :element-id="key"
              @removeSearchElement="removeSearchElementFromProxy"
            ></search-tag>
          </template>

          <div
            v-show="
              dataLoaded && filteredAndSortedTestStudios.items.length == 0
            "
            class="bg-white p-3 rounded"
          >
            <h2 class="isi-heading-gray">
              There are no Test Studios that match your criteria.
            </h2>
          </div>
          <div>
            <test-studio
              v-for="testStudio in filteredAndSortedTestStudios.items"
              :item="testStudio"
              :details="filteredAndSortedTestStudios.details"
              :key="'testStudio-' + testStudio.id"
            />
          </div>
        </mdb-col>
      </mdb-row>
    </mdb-container>
    <app-footer />
  </div>
</template>

<script>
import ShareSearchButton from "../components/Search/ShareSearchButton.vue";
import SearchBar from "../components/Search/SearchBar.vue";
import TestStudio from "../components/TestStudio/TestStudio.vue";
import SearchTag from "../components/Search/SearchTag.vue";
import BingLocationMap from "../components/BingLocationMap.vue";
import AppFooter from "../components/Footer.vue";
import { Sticky, mdbSmooth } from "mdbvue";

export default {
  components: {
    BingLocationMap,
    ShareSearchButton,
    SearchBar,
    TestStudio,
    SearchTag,
    AppFooter,
  },
  directives: {
    mdbSticky: Sticky,
    mdbSmooth,
  },
  name: "Search",
  metaInfo: {
    title: "Search",
    titleTemplate: "%s | isi Test Studio Finder",
  },
  data() {
    return {
      unwatchDataLoaded: null,
      mapRendered: false,
      showMaps: false,
      showScrollToTop: false,
    };
  },
  created() {
    if (this.dataLoaded) {
      this.handleSharedUrl();
    } else {
      // store function to remove watcher (is returned by this.$watch)
      this.unwatchDataLoaded = this.$watch("dataLoaded", this.handleSharedUrl);
    }
    setInterval(() => {
      if (window.pageYOffset < 2400) {
        if (this.showScrollToTop == true) {
          this.showScrollToTop = false;
        }
      } else if (this.showScrollToTop == false) {
        this.showScrollToTop = true;
      }
    }, 250);
  },
  methods: {
    handleMapsButtonClicked() {
      if (!this.$store.state.bingAccepted) {
        this.$store.commit("setCurrentModal", {
          type: "MapsDataPrivacyModal",
          options: {
            callback: this.handleMapsButtonClicked,
          },
        });
        return;
      }

      if (!this.mapRendered) this.mapRendered = true;
      this.showMaps = true;
    },
    removeSearchElementFromProxy(elementId) {
      let type = elementId.split("-")[0];
      let id = parseInt(elementId.split("-")[1]);
      if (type == "f") {
        this.$store.commit("toggleSearchFeature", id);
        this.$refs.searchBar.deselectFeature(id);
      } else if (type == "country") {
        this.$store.commit("toggleSearchCountry", id);
        this.$refs.searchBar.deselectCountry(id);
      } else {
        throw "unexpected type prefix";
      }
    },
    handleSharedUrl() {
      if (typeof this.unwatchDataLoaded === "function") {
        this.unwatchDataLoaded();
      }
      if (this.$route.query.testType) {
        // shared search

        let params = {};
        params.testType = parseInt(this.$route.query.testType);
        params.countries = this.$route.query.countries;
        params.features = this.$route.query.features;

        window.history.replaceState(
          {},
          document.title,
          this.$router.currentRoute.path
        );

        let searchParams = { testType: null, countries: [], features: [] };

        let t = parseInt(params.testType);
        if (!this.$store.state.testTypes.map((x) => x.id).includes(t)) {
          return;
        }

        searchParams.testType = params.testType;

        if (params.countries) {
          let c = params.countries.split(",");
          c = c.map((x) => parseInt(x));

          for (let el of c) {
            if (
              this.$store.state.countries.map((x) => x.id).includes(el) &&
              !searchParams.countries.includes(el)
            )
              searchParams.countries.push(el);
          }
        }

        if (params.features) {
          let c = params.features.split(",");
          c = c.map((x) => parseInt(x));

          for (let el of c) {
            if (
              Object.prototype.hasOwnProperty.call(
                this.$store.state.features,
                el
              ) &&
              !searchParams.features.includes(el)
            )
              searchParams.features.push(el);
          }
        }

        if (
          this.user &&
          this.user.requestList.testType &&
          this.user.requestList.testType != searchParams.testType &&
          this.user.requestList.testStudioIds.length > 0
        ) {
          this.$store.commit("setCurrentModal", {
            type: "testTypemismatchModal",
            options: {
              clearRequestList: true,
              adjustSearch: true,
              back: false,
              searchParamsProxy: searchParams,
            },
          });
        } else {
          this.$store.commit("setSearchParams", searchParams);
        }
      }
    },
  },
  computed: {
    searchBarRenderKey() {
      return this.$store.getters.searchBarRenderKey;
    },
    searchTags() {
      let names = {};

      for (let el of this.$store.state.searchParams.countries) {
        names["country-" + el] = this.$store.state.countries.find(
          (x) => x.id == el
        ).displayName;
      }

      for (let el of this.$store.state.searchParams.features) {
        if (this.$store.state.features[el].displayNameShort) {
          names["f-" + el] = this.$store.state.features[el].displayNameShort;
        } else {
          names["f-" + el] = this.$store.state.features[el].displayName;
        }
      }

      return names;
    },
    dataLoaded() {
      return this.$store.state.dataLoaded;
    },
    filteredAndSortedTestStudios() {
      return this.$store.getters.filteredAndSortedTestStudios;
    },
    user() {
      return this.$store.state.user;
    },
  },
};
</script>

<style lang="scss">
.search {
  min-height: calc(100vh - 360px);
}
@import "../styles/views/_search.scss";
.search__scroll-top-button {
  bottom: 22px;
  right: 15px;
}
</style>

<style scoped>
@media (min-width: 992px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1200px) {
  .container {
    max-width: 1370px;
  }
}
</style>